import { FaUserCheck, FaUserSlash } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

export const ICON = {
  delete: <MdDelete />,
  block: <FaUserSlash />,
  unblock: <FaUserCheck />,
};
